<template>
  <div>
    <div>
      <Form label-position="left">
        <h3>
          订单号：{{ orderDetail.orderId }}
          <Tag color="red">{{ orderDetail.status | statusFilter }}</Tag>
        </h3>
        <h4>基本信息</h4>
        <Row>
          <Col span="8">
            <FormItem label="订单号：">
              <p>{{ orderDetail.orderId }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="三方订单号：">
              <p>
                {{ orderDetail.groupCode ? orderDetail.groupCode : "暂无" }}
              </p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="下单时间：">
              <p>{{ orderDetail.orderTime }}</p>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="订单来源：">
              <p>
                {{ orderDetail.groupCode ? orderDetail.groupCode : "暂无" }}
              </p>
            </FormItem>
          </Col>
        </Row>
        <Divider :dashed="true"></Divider>
        <template>
          <h4>支付信息</h4>
          <Row>
            <Col span="8">
              <FormItem label="支付单号：">
                <p>
                  {{
                    orderDetail.paymentInfo &&
                    orderDetail.paymentInfo.sequenceNo
                  }}
                </p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="支付状态：">
                <p>{{ orderDetail.status | statusFilter }}</p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="支付方式：">
                <p>
                  {{
                    orderDetail.payChannelName
                      ? orderDetail.payChannelName
                      : orderDetail.payChannelCode
                  }}
                </p>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="支付时间：">
                <p>{{ orderDetail.payTime }}</p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="总金额：">
                <p>{{ orderDetail.realTotalAmt }}</p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="支付金额：">
                <p>
                  {{
                    orderDetail.paymentInfo && orderDetail.paymentInfo.payAmt
                  }}
                </p>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="返利钱包：">
                <p>{{ orderDetail.discountTotalAmt }}</p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="优惠金额">
                <p>{{ orderDetail.discountTotalAmt }}</p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="付款人：">
                <p>
                  {{
                    (orderDetail.paymentInfo &&
                      orderDetail.paymentInfo.payerName) ||
                    "暂无"
                  }}
                </p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="付款凭证：">
                <p>{{ orderDetail.groupCode || "暂无" }}</p>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="凭证备注：">
                <p>{{ orderDetail.groupCode || "暂无" }}</p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="订单备注：">
                <p>{{ orderDetail.remark || "暂无" }}</p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="单位：">
                <p>{{ orderDetail.groupCode || "暂无" }}</p>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="开户行：">
                <p>
                  {{
                    (orderDetail.paymentInfo &&
                      orderDetail.paymentInfo.bankName) ||
                    "暂无"
                  }}
                </p>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="银行账号：">
                <p>
                  {{
                    (orderDetail.paymentInfo &&
                      orderDetail.paymentInfo.bankAccount) ||
                    "暂无"
                  }}
                </p>
              </FormItem>
            </Col>
          </Row>
          <Divider :dashed="true"></Divider>
        </template>
        <h4>收货信息</h4>
        <Row>
          <Col span="8">
            <FormItem label="收货人：">
              <p>
                {{
                  orderDetail.addressInfo &&
                  orderDetail.addressInfo.receivePerson
                }}
              </p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="收货门店：">
              <p>
                {{ orderDetail.addressInfo && orderDetail.addressInfo.retName }}
              </p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="联系电话：">
              <p>
                {{
                  orderDetail.addressInfo &&
                  orderDetail.addressInfo.receiveMobile
                }}
              </p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="收货地址：">
              <p>
                {{ orderDetail.addressInfo && orderDetail.addressInfo.addr }}
              </p>
            </FormItem>
          </Col>
        </Row>
        <Divider :dashed="true"></Divider>
        <h4>门店信息</h4>
        <Row>
          <Col span="8">
            <FormItem label="下单门店ID：">
              <p>{{ orderDetail.groupCode }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="下单门店：">
              <p>{{ orderDetail.retName }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="下单门店类型：">
              <p>{{ orderDetail.retType | retTypeFilter }}</p>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="联系电话：">
              <p>{{ orderDetail.groupCode || "暂无" }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="业务员：">
              <p>{{ orderDetail.groupCode || "暂无" }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="关联运营方：">
              <p>{{ orderDetail.groupCode || "暂无" }}</p>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="关联经销商：">
              <p>{{ orderDetail.groupCode || "暂无" }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="关联服务商：">
              <p>{{ orderDetail.groupCode || "暂无" }}</p>
            </FormItem>
          </Col>
        </Row>
        <Divider :dashed="true"></Divider>
        <div
          v-if="
            orderDetail.logisticsInfoList &&
            orderDetail.logisticsInfoList.length > 0
          "
        >
          <h4>物流信息</h4>
          <Row>
            <Col
              span="24"
              v-for="(item, index) in orderDetail.logisticsInfoList"
              :key="index"
              style="margin-left: 30px; margin-top: 15px"
            >
              {{ item.logisticsName }}:
              <a style="margin-left: 15px" @click="openLogistic(item)">{{
                item.logisticsOrderNo
              }}</a>
            </Col>
          </Row>
          <Divider :dashed="true"></Divider>
        </div>

        <Tabs>
          <TabPane label="商品信息">
            <Table
              :columns="prdColumns"
              border
              :data="orderDetail.skuList || []"
            >
              <template slot-scope="{ row }" slot="shopInfo">
                <div class="flex-row pd20">
                  <img
                    :src="row.coverImgUrl"
                    class="cover_img"
                    alt="暂无图片"
                  />
                  <p>{{ row.skuName }}</p>
                </div>
              </template>
            </Table>
            <div style="margin-top: 20px; text-align: right">
              <div>商品金额：{{ orderDetail.skuTotalAmt }}¥</div>
              <div>运费：{{ orderDetail.transFeeAmt }}¥</div>
              <div>优惠金额：{{ 0 }}¥</div>
              <div>应支付：{{ orderDetail.discountTotalAmt }}¥</div>
              <div>返利钱包：{{ 0 }}¥</div>
              <div>实付款：{{ orderDetail.payAmt }}¥</div>
            </div>
          </TabPane>
          <TabPane label="订单日志">
            <Table :columns="optColumns" :data="orderDetail.optLogList || []">
              <template slot-scope="{ row }" slot="statusOld">
                <span>{{ row.statusNew | statusFilter }}</span>
              </template>
              <template slot-scope="{ row }" slot="statusNew">
                <span>{{ row.statusNew | statusFilter }}</span>
              </template>
            </Table>
          </TabPane>
        </Tabs>
      </Form>
      <Modal v-model="logis_modal" title="物流追踪" closable width="650">
        <Steps :current="0" direction="vertical">
          <Step
            :title="item.logisticsContext"
            :content="item.logisticsTime"
            v-for="(item, index) in logsi_list"
            :key="index"
            :icon="index == 0 ? 'ios-radio-button-on' : 'ios-radio-button-off'"
          ></Step>
        </Steps>
        <div slot="footer"></div>
      </Modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      params: {},
      prdColumns: [
        {
          title: "商品信息",
          slot: "shopInfo",
          width: 300,
        },
        {
          title: "分类",
          key: "operateType",
        },
        {
          title: "品牌",
          key: "brandName",
        },
        {
          title: "单价(元)",
          key: "skuPrice",
        },
        {
          title: "购买数量",
          key: "count",
        },
        {
          title: "小计(元)",
          key: "skuTotalAmt",
        },
      ],
      optColumns: [
        {
          title: "操作人",
          key: "operatorName",
        },
        {
          title: "操作类型",
          key: "operateType",
        },
        {
          title: "时间",
          key: "operatorTime",
        },
        {
          title: "变更前状态",
          slot: "statusOld",
        },
        {
          title: "变更后状态",
          slot: "statusNew",
        },
        {
          title: "备注",
          key: "ext",
        },
      ],
      logis_modal: false, //物流弹框
      logsi_list: [],
    };
  },
  computed: {
    ...mapGetters({
      orderDetail: "order/getOrderDetail",
    }),
  },
  filters: {
    statusFilter(status) {
      let sTxt = "";
      switch (+status) {
        case 30:
          sTxt = "待发货";
          break;
        case 40:
          sTxt = "已发货";
          break;
        case 45:
          sTxt = "已完成";
          break;
        case 0:
          sTxt = "已关闭";
          break;
        case 10:
          sTxt = "待付款";
          break;
        case 21:
          sTxt = "待确认";
          break;
        default:
          break;
      }

      return sTxt;
    },
    retTypeFilter(retType) {
      let type_list = [
        {
          retType: 0,
          name: "直接订货门店",
        },
        {
          retType: 1,
          name: "总仓配货门店",
        },
        {
          retType: 2,
          name: "总仓和门店",
        },
        {
          retType: 3,
          name: "总仓",
        },
        {
          retType: 21,
          name: "联盟总店",
        },
        {
          retType: 22,
          name: "联盟分店",
        },
      ];
      if (retType) {
        return type_list.filter((item) => item.retType == retType)[0].name;
      } else {
        return "无";
      }
    },
  },
  created() {
    this.getDetail();
  },
  mounted() {},
  methods: {
    openLogistic(item) {
      this.logsi_list = item.packInfos;
      this.$nextTick(() => {
        this.logis_modal = true;
      });
    },
    getDetail() {
      this.$store
        .dispatch("order/getOrderDetail", {
          orderId: this.$route.query.orderId,
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
  },
};
</script>

<style>
.ivu-steps .ivu-steps-head-inner > .ivu-steps-icon.ivu-icon {
  font-size: 16px;
}
.flex-row {
  display: flex;
  align-items: center;
}
.cover_img {
  border: 1px solid #ccc;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  margin-right: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.pd20 {
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/order/detail.vue